import { Component, Input, OnInit } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';

import { GetEnumValuesDto } from 'src/app/core/api/models';
import { EnumsService, PrivateNumbersService } from 'src/app/core/api/services';
import { EnumToTextConvertorPipe } from 'src/app/core/pipes/enum-text.pipe';
import { SavedEnumsService } from 'src/app/core/services/saved-enums.service';
import { BaseSelectionList } from '../base/base-selection-list.component';

@Component({
    selector: 'private-number-selection-list',
    templateUrl: './private-number-selection-list.component.html',
    standalone: false
})
export class PrivateNumberSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  @Input('sendType') sendType;
  @Input('useType') useType;

  SmsCpTypesEnumValues: GetEnumValuesDto[] = [];

  constructor(
    protected currentService: PrivateNumbersService,
    private enumService: EnumsService,
    private enumToTextConvertorPipe: EnumToTextConvertorPipe
  ) {
    super();
  }

  ngOnInit() {
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => {
        this.SmsCpTypesEnumValues = values;
        this.initConfig();
        this.getItems();
      });
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'optionTitle';
    this.sortKey = 'id';

    if (!this.input_label) this.input_label = 'common.privateNumber';
  }

  getItems() {
    if (this.loading) return;
    this.loading = true;
    // privateNumbers
    this.currentService
      .privateNumbersGetUserPrivateNumbersForSend(
        this.sendType ? { SendType: this.sendType } : {}
      )
      .pipe(
        this.baseSelectionSearchPipeOperators,
        map((items) => {
          return items.data.map((item) => {
            const translatedSmsCpType = this.enumToTextConvertorPipe.transform(
              item.smsCp,
              this.SmsCpTypesEnumValues
            );
            return {
              ...item,
              optionTitle: `${item.number} (${translatedSmsCpType})`,
            };
          });
        })
      )
      .subscribe((items) => {
        this.items = items;
      });
  }

  getEnumValuesApi(enumName): any {
    // Observable<GetEnumValuesDto[]> { TODO torbatian
    if (SavedEnumsService.getEnum(enumName) != null)
      return SavedEnumsService.getEnumAsObservable(enumName);

    this.enumService
      .enumsGetEnumValues({ EnumTypeName: enumName })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((newEnum) => {
        SavedEnumsService.pushEnum({
          enumName: enumName,
          enumValue: newEnum.data,
        });
      });

    // save enum
    return this.enumService.enumsGetEnumValues({ EnumTypeName: enumName }).pipe(
      takeUntil(this.onDestroy$),
      map((res) => res.data)
    );
  }
}
